import { format, parseISO } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

export const displaySnapshotTime = (isoTimestamp, locale) => {
  const date = parseISO(isoTimestamp);
  const dateFormat = 'MMMM d, yyyy'; // Format: "July 2, 2024"
  const selectedLocale = locale === 'fr' ? fr : enUS;

  return format(date, dateFormat, { locale: selectedLocale });
};

export const getUUIDFromURL = () => {
  // Get the pathname from the current URL
  const pathname = window.location.pathname;

  // Define a regex pattern to match any characters after /c/ and before an optional trailing slash
  const uuidPattern = /^\/c\/([^/]+)\/?$/;

  // Use the pattern to extract the UUID
  const match = pathname.match(uuidPattern);

  // Return the UUID if matched, otherwise return null
  return match ? match[1] : null;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// The backend answers 404 both for a snapshot the owner deleted or unpublished and for an id that
// never existed, and getUUIDFromURL above accepts any non-slash segment. Only the well-formed case
// may be reported as "removed by its owner"; anything else is a genuine not-found.
export const isRemovedSnapshot = (error, uuid) =>
  error?.status === 404 && UUID_PATTERN.test(uuid ?? '');
